import React, { Component } from 'react';
import { Glyphicon, Image, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { AdminLinkContainer } from '../AdminLinkContainer';
import { LinkContainer } from 'react-router-bootstrap';
import AuthService from "../../services/auth.service";
import '../../content/css/ContractReviewer.css';
import ExportDocumentModal from './ExportDocumentModal';
import { PrivateLinkContainer } from '../PrivateLinkContainer';
import SettingsModal from './SettingsModal';

var logo = require("../../content/images/icon_color.svg");

export default class NavMenu extends Component {
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.state = {
            showSurvey: false,
            surveyLoaded: false
        };
    }

    componentDidMount() {
        if (!this.authService.hasShownSurvey()) {
            this.setState({ showSurvey: true }, () => {
                this.loadSurveyScript();
                this.authService.setHasShownSurvey();
            });
        }
    }

    loadSurveyScript = () => {
        if (!this.state.surveyLoaded) {
            const script = document.createElement("script");
            script.src = "https://js-eu1.hsforms.net/forms/embed/24914322.js";
            script.async = true;
            document.body.appendChild(script);
            this.setState({ surveyLoaded: true });
        }
    };

    openSurvey = () => {
        this.loadSurveyScript();
        this.setState({ showSurvey: true });
    };

    closeSurvey = () => {
        this.setState({ showSurvey: false });
    };

    getTooltip(text) {
        return (
            <Tooltip placement="right">
                {text}
            </Tooltip>
        );
    }

    render() {
        let isAuthenticated = this.authService.isAuthenticated();
        let isGuest = this.authService.isGuest();
        let isAdmin = this.authService.isAdmin();
        let linkBase = this.props.reportId ? `/reports/${this.props.reportId}/document` : "";
        let isHannes = this.authService.getUserId() === "auth0|61b89867eab084006aa0de51";
        let isAroyMspcorp = this.authService.getUserId() === "auth0|667493eb242c12db87b467c2";
        let isJMELegal = this.authService.getUserId() === "auth0|66f57f64972b5e0dfe11d94c";

        return (
            <div className="nav-menu">
                <div className="upper">
                    <LinkContainer to='/'>
                        <Image className="logo" src={logo} />
                    </LinkContainer>

                    <OverlayTrigger overlay={this.getTooltip("Home")}>
                        <div>
                            <LinkContainer exact={true} to={`/`}>
                                <div className="menu-btn">
                                    <Glyphicon glyph="home" />
                                </div>
                            </LinkContainer>
                        </div>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={this.getTooltip("My documents")}>
                        <div>
                            <LinkContainer to={`/documents`}>
                                <div className="menu-btn">
                                    <Glyphicon glyph="briefcase" />
                                </div>
                            </LinkContainer>
                        </div>
                    </OverlayTrigger>

                    {(isAdmin || isHannes || isAroyMspcorp || isJMELegal) &&
                        <OverlayTrigger overlay={this.getTooltip("My reports")}>
                            <div>
                                <LinkContainer to={`/reports`}>
                                    <div className="menu-btn">
                                        <Glyphicon glyph="tasks" />
                                    </div>
                                </LinkContainer>
                            </div>
                        </OverlayTrigger>
                    }

                    <OverlayTrigger overlay={this.getTooltip("My themes")}>
                        <div>
                            <PrivateLinkContainer to={`/themes`}>
                                <div className="menu-btn">
                                    <Glyphicon glyph="tags" />
                                </div>
                            </PrivateLinkContainer>
                        </div>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={this.getTooltip("Upload new document")}>
                        <div>
                            <LinkContainer to={`/upload`}>
                                <div className="menu-btn">
                                    <Glyphicon glyph="upload" />
                                </div>
                            </LinkContainer>
                        </div>
                    </OverlayTrigger>

                    <OverlayTrigger overlay={this.getTooltip("Admin tools")}>
                        <div>
                            <AdminLinkContainer to={`/dashboard/themes`}>
                                <div className="menu-btn">
                                    <Glyphicon glyph="wrench" />
                                </div>
                            </AdminLinkContainer>
                        </div>
                    </OverlayTrigger>

                    {this.props.id !== "" &&
                        <React.Fragment>
                            <hr />

                            <OverlayTrigger overlay={this.getTooltip("Document overview")}>
                                <div>
                                    <LinkContainer to={`${linkBase}/${this.props.id}`}>
                                        <div className="document-btn overview-btn">
                                            <Glyphicon glyph="align-left" />
                                            <span className="highlight-count"><strong>{this.props.highlightCount}</strong></span>
                                        </div>
                                    </LinkContainer>
                                </div>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={this.getTooltip("Missing concepts")}>
                                <div>
                                    <LinkContainer to={`${linkBase}/${this.props.id}/missing`}>
                                        <div className="document-btn missing-btn">
                                            <Glyphicon glyph="exclamation-sign" />
                                            <span className="highlight-count"><strong>{this.props.missingCount}</strong></span>
                                        </div>
                                    </LinkContainer>
                                </div>
                            </OverlayTrigger>

                            <OverlayTrigger overlay={this.getTooltip("Document viewer")}>
                                <div>
                                    <LinkContainer to={`${linkBase}/${this.props.id}/viewer/1`}>
                                        <div className="document-btn viewer-btn">
                                            <Glyphicon glyph="file" />
                                            <span className="highlight-count"><strong>{this.props.highlightCount}</strong></span>
                                        </div>
                                    </LinkContainer>
                                </div>
                            </OverlayTrigger>

                            <ExportDocumentModal />
                            <hr />
                        </React.Fragment>
                    }
                </div>

                <div className="lower">
                    {(isGuest || isAdmin) &&
                        <OverlayTrigger overlay={this.getTooltip("Give feedback")}>
                            <div>
                                <div className="menu-btn" onClick={this.openSurvey}>
                                    <Glyphicon glyph="comment" />
                                </div>
                            </div>
                        </OverlayTrigger>
                    }
                    {isAdmin &&
                        <SettingsModal />
                    }
                    <div>
                        {isAuthenticated &&
                            <OverlayTrigger overlay={this.getTooltip("Logout")}>
                                <div onClick={() => this.authService.logout()} className="menu-btn">
                                    <Glyphicon glyph="log-out" />
                                </div>
                            </OverlayTrigger>
                        }
                        {isGuest &&
                            <OverlayTrigger overlay={this.getTooltip("Login")}>
                                <div className="menu-btn">
                                    <LinkContainer to={`/login`}>
                                        <Glyphicon glyph="log-in" />
                                    </LinkContainer>
                                </div>
                            </OverlayTrigger>
                        }
                    </div>
                </div>

                <Modal show={this.state.showSurvey} onHide={this.closeSurvey} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>We'd love your feedback</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div
                            className="hs-form-frame"
                            data-region="eu1"
                            data-form-id="54a7af81-f74e-4740-85e3-03172fa32614"
                            data-portal-id="24914322"
                        ></div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/NavMenu.js